import { useState, useCallback } from 'react';

export default function usePendingConfigRows() {
  const [pending, setPending] = useState([]);

  const add = useCallback((row) => setPending(prev => [...prev, row]), []);
  const addMany = useCallback((rows) => setPending(prev => [...prev, ...rows]), []);
  const updateAt = useCallback((idx, updated) =>
    setPending(prev => prev.map((r, i) => (i === idx ? { ...updated } : r))), []);
  const removeAt = useCallback((idx) =>
    setPending(prev => prev.filter((_, i) => i !== idx)), []);
  const clear = useCallback(() => setPending([]), []);

  return { pending, setPending, add, addMany, updateAt, removeAt, clear };
}
